import { useIntl } from '@topwrite/common';

interface Props {
    children: number;
}

export default function FormatCurrency({ children }: Props) {
    const intl = useIntl();

    return <>{intl.formatNumber(children / 100, { style: 'currency', currency: 'CNY' })}</>;
}
